import { render, staticRenderFns } from "./Employee_study_wrap.vue?vue&type=template&id=2ee71872"
import script from "./Employee_study_wrap.vue?vue&type=script&lang=js"
export * from "./Employee_study_wrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports